import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import PrivateLayout from "../components/layouts/PrivateLayout";
import Home from "../pages/home/Home";
import LoginPage from "../pages/auth/LoginPage";
import PublicLayout from "../components/layouts/PublicLayout";
import AuthProvider from "../context/AuthProvider";

export default function AppRouter() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/auth" element={<PublicLayout />}>
            <Route index element={<LoginPage />} />
          </Route>
          <Route path="/" element={<PrivateLayout />}>
            <Route index element={<Home />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}
